import { createRoot } from 'react-dom/client';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './nls/i18n';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(<App />);